import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/privacy-policy" className="footer-link">
            プライバシーポリシー
          </Link>
        </div>
        <p>&copy; 2024 スマート税金アシスタント. All rights reserved.</p>
        <p className="footer-note">
          ※ 計算結果は概算値です。正確な金額については税理士にご相談ください。
        </p>
      </div>
    </footer>
  );
};

export default Footer;